import axios from "axios";
import React, { useEffect, useState, useMemo } from "react";
import { GET_ALLLINKFEATURE_API } from "../../utils/services";
import { extractDomain } from "../../../helperJs/helper";
import { CSVLink } from "react-csv";
import { Button } from "@mui/material";
import CustomTable from "../../../Mycomponent/share/customTable";
import { ZustandStore } from "../../../store/zustand-store";
import { DottLoader } from "../../../Mycomponent/share/loader";
import { DateFormat } from "../../../Mycomponent/share/upDater/constant";

const InterestPost = () => {
  const [adsy, setAdsy] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [page, setPage] = React.useState(1);

  const handleGetAllLinkFeature = async () => {
    try {
      const resp = await axios.get(GET_ALLLINKFEATURE_API());
      setAdsy({
        data: resp.data || [],
        loading: false,
        error: null,
      });
    } catch (error) {
      setAdsy({
        data: [],
        loading: false,
        error,
      });
    }
  };

  useEffect(() => {
    handleGetAllLinkFeature();
  }, []);

  const tableHeader = useMemo(() => {
    return [
      {
        label: "NAME",
        key: "name",
        minWidth: 100,
        align: "left",
        width: "25%",
      },
      {
        label: "EMAIL",
        key: "email",
        minWidth: 120,
        width: "25%",
        align: "left",
      },
      {
        label: "PHONE",
        key: "phone",
        minWidth: 100,
        align: "center",
        width: "25%",
      },
      {
        label: "Domain",
        key: "domain",
        minWidth: 120,
        align: "center",
        width: "25%",
      },
      {
        label: "WEBSITE",
        key: "website",
        minWidth: 120,
        align: "center",
        width: "25%",
      },
      {
        label: "BUDGET",
        key: "budget",
        minWidth: 120,
        align: "center",
        width: "25%",
      },
      {
        label: "Date",
        key: "date",
        minWidth: 120,
        align: "center",
        width: "25%",
      },
    ];
  }, []);

  const rows = useMemo(() => {
    if (!adsy.data || adsy?.data?.length === 0) return [];
    return adsy?.data?.map((item, index) => {
      const domain = extractDomain(item?.data?.[0].URL);
      return {
        id: index,
        name: item.name,
        email: item.email,
        phone: item.phone,
        domain,
        website: item.website,
        budget: item.budget,
        date: DateFormat(item.date),
      };
    });
  }, [adsy]);

  return (
    <>
      <CustomTable
        showSearchBar={true}
        tableHeader={tableHeader}
        dataLoader={adsy.loading}
        rows={rows}
        page={page}
        setPage={setPage}
        tableTitle=""
        downloadCSVFile={
          <CSVLink data={rows} filename={"SEO Tools: Buy Guest Posts.csv"}>
            <Button className="btn_1 ms-2">Download CSV</Button>
          </CSVLink>
        }
      />
    </>
  );
};

export default InterestPost;
